// extracted by mini-css-extract-plugin
export default {"ContentCenteredLayout":"ContentCenteredLayout__ContentCenteredLayout___XPimw","content":"ContentCenteredLayout__content___HtsUp"};